import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

const shuffleArrayDef = (array: string[]) => {
  const sortedArr = structuredClone(array);
  for (let i = sortedArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [sortedArr[i], sortedArr[j]] = [sortedArr[j], sortedArr[i]];
  }
  return sortedArr;
};

const questionSet1 = [
  'q1',
  'q2',
  'q3',
  'q4',
  'q5',
  'q6',
  'q7',
  'q8',
  'q9',
  'q10',
  'q11',
  'q12',
  'q13',
  'q14',
  'q15',
  'q16',
  'q17',
  'q18',
  'q19',
  'q20',
  'q21',
];

const shuffleArray = shuffleArrayDef(questionSet1);

const checknext = (id: string) => {
  for (let i = 0; i < shuffleArray.length; i++) {
    if (shuffleArray[i].toString() === id.toString()) {
      if (i + 1 >= shuffleArray.length) {
        return shuffleArray[0];
      } else {
        return shuffleArray[i + 1];
      }
    }
  }
};

const questionArray = [
  {
    id: 'q1',
    questionNumber: 1,
    type: 'single-option-media',
    category: '2024-Report',
    shuffleArray: shuffleArray,
    title: <FormattedMessage {...messages.q1Title} />,
    options: [
      {
        optionId: '01option02',
        text: <FormattedMessage {...messages.q1option02} />,
        correctAnswer: 0,
        nextStep: checknext('q1'),
      },
      {
        optionId: 'q01option01',
        text: <FormattedMessage {...messages.q1option01} />,
        correctAnswer: 1,
        nextStep: checknext('q1'),
      },
      {
        optionId: '01option03',
        text: <FormattedMessage {...messages.q1option03} />,
        correctAnswer: 0,
        nextStep: checknext('q1'),
      },
      {
        optionId: '01option04',
        text: <FormattedMessage {...messages.q1option04} />,
        correctAnswer: 0,
        nextStep: checknext('q1'),
      },
    ],
  },
  {
    id: 'q2',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q2Title} />,
    options: [
      {
        optionId: 'q02option01',
        text: <FormattedMessage {...messages.q2option01} />,
        correctAnswer: 1,
        nextStep: checknext('q2'),
      },
      {
        optionId: '02option02',
        text: <FormattedMessage {...messages.q2option02} />,
        correctAnswer: 0,
        nextStep: checknext('q2'),
      },
      {
        optionId: '02option03',
        text: <FormattedMessage {...messages.q2option03} />,
        correctAnswer: 0,
        nextStep: checknext('q2'),
      },
      {
        optionId: '02option04',
        text: <FormattedMessage {...messages.q2option04} />,
        correctAnswer: 0,
        nextStep: checknext('q2'),
      },
    ],
  },
  {
    id: 'q3',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q3Title} />,
    options: [
      {
        optionId: '03option02',
        text: <FormattedMessage {...messages.q3option02} />,
        correctAnswer: 0,
        nextStep: checknext('q3'),
      },
      {
        optionId: '03option03',
        text: <FormattedMessage {...messages.q3option03} />,
        correctAnswer: 0,
        nextStep: checknext('q3'),
      },
      {
        optionId: '03option04',
        text: <FormattedMessage {...messages.q3option04} />,
        correctAnswer: 0,
        nextStep: checknext('q3'),
      },
      {
        optionId: '03option01',
        text: <FormattedMessage {...messages.q3option01} />,
        correctAnswer: 1,
        nextStep: checknext('q3'),
      },
    ],
  },
  {
    id: 'q4',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q4Title} />,
    options: [
      {
        optionId: '04option01',
        text: <FormattedMessage {...messages.q4option02} />,
        correctAnswer: 0,
        nextStep: checknext('q4'),
      },
      {
        optionId: '04option01',
        text: <FormattedMessage {...messages.q4option01} />,
        correctAnswer: 1,
        nextStep: checknext('q4'),
      },
      {
        optionId: '04option01',
        text: <FormattedMessage {...messages.q4option03} />,
        correctAnswer: 0,
        nextStep: checknext('q4'),
      },
      {
        optionId: '04option04',
        text: <FormattedMessage {...messages.q4option04} />,
        correctAnswer: 0,
        nextStep: checknext('q4'),
      },
    ],
  },
  {
    id: 'q5',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q5Title} />,
    options: [
      {
        optionId: '05option02',
        text: <FormattedMessage {...messages.q5option02} />,
        correctAnswer: 0,
        nextStep: checknext('q5'),
      },
      {
        optionId: '05option03',
        text: <FormattedMessage {...messages.q5option03} />,
        correctAnswer: 0,
        nextStep: checknext('q5'),
      },
      {
        optionId: '05option01',
        text: <FormattedMessage {...messages.q5option01} />,
        correctAnswer: 1,
        nextStep: checknext('q5'),
      },
      {
        optionId: '05option04',
        text: <FormattedMessage {...messages.q5option04} />,
        correctAnswer: 0,
        nextStep: checknext('q5'),
      },
    ],
  },
  {
    id: 'q6',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q6Title} />,
    options: [
      {
        optionId: '06option01',
        text: <FormattedMessage {...messages.q6option01} />,
        correctAnswer: 1,
        nextStep: checknext('q6'),
      },
      {
        optionId: '06option02',
        text: <FormattedMessage {...messages.q6option02} />,
        correctAnswer: 0,
        nextStep: checknext('q6'),
      },
      {
        optionId: '06option03',
        text: <FormattedMessage {...messages.q6option03} />,
        correctAnswer: 0,
        nextStep: checknext('q6'),
      },
      {
        optionId: '06option04',
        text: <FormattedMessage {...messages.q6option04} />,
        correctAnswer: 0,
        nextStep: checknext('q6'),
      },
    ],
  },
  {
    id: 'q7',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q7Title} />,
    options: [
      {
        optionId: '07option02',
        text: <FormattedMessage {...messages.q7option02} />,
        correctAnswer: 0,
        nextStep: checknext('q7'),
      },
      {
        optionId: '07option03',
        text: <FormattedMessage {...messages.q7option03} />,
        correctAnswer: 0,
        nextStep: checknext('q7'),
      },
      {
        optionId: '07option01',
        text: <FormattedMessage {...messages.q7option01} />,
        correctAnswer: 1,
        nextStep: checknext('q7'),
      },
      {
        optionId: '07option04',
        text: <FormattedMessage {...messages.q7option04} />,
        correctAnswer: 0,
        nextStep: checknext('q7'),
      },
    ],
  },
  {
    id: 'q8',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q8Title} />,
    options: [
      {
        optionId: '08option02',
        text: <FormattedMessage {...messages.q8option02} />,
        correctAnswer: 0,
        nextStep: checknext('q8'),
      },
      {
        optionId: '08option01',
        text: <FormattedMessage {...messages.q8option01} />,
        correctAnswer: 1,
        nextStep: checknext('q8'),
      },
      {
        optionId: '08option03',
        text: <FormattedMessage {...messages.q8option03} />,
        correctAnswer: 0,
        nextStep: checknext('q8'),
      },
      {
        optionId: '08option04',
        text: <FormattedMessage {...messages.q8option04} />,
        correctAnswer: 0,
        nextStep: checknext('q8'),
      },
    ],
  },
  {
    id: 'q9',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q9Title} />,
    options: [
      {
        optionId: '09option02',
        text: <FormattedMessage {...messages.q9option02} />,
        correctAnswer: 0,
        nextStep: checknext('q9'),
      },
      {
        optionId: '09option03',
        text: <FormattedMessage {...messages.q9option03} />,
        correctAnswer: 0,
        nextStep: checknext('q9'),
      },
      {
        optionId: '09option04',
        text: <FormattedMessage {...messages.q9option04} />,
        correctAnswer: 0,
        nextStep: checknext('q9'),
      },
      {
        optionId: '09option01',
        text: <FormattedMessage {...messages.q9option01} />,
        correctAnswer: 1,
        nextStep: checknext('q9'),
      },
    ],
  },
  {
    id: 'q10',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q10Title} />,
    options: [
      {
        optionId: '10option01',
        text: <FormattedMessage {...messages.q10option01} />,
        correctAnswer: 1,
        nextStep: checknext('q10'),
      },
      {
        optionId: '10option02',
        text: <FormattedMessage {...messages.q10option02} />,
        correctAnswer: 0,
        nextStep: checknext('q10'),
      },
      {
        optionId: '10option03',
        text: <FormattedMessage {...messages.q10option03} />,
        correctAnswer: 0,
        nextStep: checknext('q10'),
      },
      {
        optionId: '10option04',
        text: <FormattedMessage {...messages.q10option04} />,
        correctAnswer: 0,
        nextStep: checknext('q10'),
      },
    ],
  },
  {
    id: 'q11',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q11Title} />,
    options: [
      {
        optionId: '11option02',
        text: <FormattedMessage {...messages.q11option02} />,
        correctAnswer: 0,
        nextStep: checknext('q11'),
      },
      {
        optionId: '11option01',
        text: <FormattedMessage {...messages.q11option01} />,
        correctAnswer: 1,
        nextStep: checknext('q11'),
      },
      {
        optionId: '11option03',
        text: <FormattedMessage {...messages.q11option03} />,
        correctAnswer: 0,
        nextStep: checknext('q11'),
      },
      {
        optionId: '11option04',
        text: <FormattedMessage {...messages.q11option04} />,
        correctAnswer: 0,
        nextStep: checknext('q11'),
      },
    ],
  },
  {
    id: 'q12',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q12Title} />,
    options: [
      {
        optionId: '12option02',
        text: <FormattedMessage {...messages.q12option02} />,
        correctAnswer: 0,
        nextStep: checknext('q12'),
      },
      {
        optionId: '12option03',
        text: <FormattedMessage {...messages.q12option03} />,
        correctAnswer: 0,
        nextStep: checknext('q12'),
      },
      {
        optionId: '12option01',
        text: <FormattedMessage {...messages.q12option01} />,
        correctAnswer: 1,
        nextStep: checknext('q12'),
      },
      {
        optionId: '12option04',
        text: <FormattedMessage {...messages.q12option04} />,
        correctAnswer: 0,
        nextStep: checknext('q12'),
      },
    ],
  },
  {
    id: 'q13',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q13Title} />,
    options: [
      {
        optionId: '13option01',
        text: <FormattedMessage {...messages.q13option01} />,
        correctAnswer: 0,
        nextStep: checknext('q13'),
      },
      {
        optionId: '13option02',
        text: <FormattedMessage {...messages.q13option02} />,
        correctAnswer: 0,
        nextStep: checknext('q13'),
      },
      {
        optionId: '13option03',
        text: <FormattedMessage {...messages.q13option03} />,
        correctAnswer: 0,
        nextStep: checknext('q13'),
      },
      {
        optionId: '13option04',
        text: <FormattedMessage {...messages.q13option04} />,
        correctAnswer: 1,
        nextStep: checknext('q13'),
      },
    ],
  },
  {
    id: 'q14',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q14Title} />,
    options: [
      {
        optionId: '14option01',
        text: <FormattedMessage {...messages.q14option01} />,
        correctAnswer: 0,
        nextStep: checknext('q14'),
      },
      {
        optionId: '14option02',
        text: <FormattedMessage {...messages.q14option02} />,
        correctAnswer: 0,
        nextStep: checknext('q14'),
      },
      {
        optionId: '14option03',
        text: <FormattedMessage {...messages.q14option03} />,
        correctAnswer: 1,
        nextStep: checknext('q14'),
      },
      {
        optionId: '14option04',
        text: <FormattedMessage {...messages.q14option04} />,
        correctAnswer: 0,
        nextStep: checknext('q14'),
      },
    ],
  },
  {
    id: 'q15',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q15Title} />,
    options: [
      {
        optionId: '15option01',
        text: <FormattedMessage {...messages.q15option01} />,
        correctAnswer: 1,
        nextStep: checknext('q15'),
      },
      {
        optionId: '15option02',
        text: <FormattedMessage {...messages.q15option02} />,
        correctAnswer: 0,
        nextStep: checknext('q15'),
      },
      {
        optionId: '15option03',
        text: <FormattedMessage {...messages.q15option03} />,
        correctAnswer: 0,
        nextStep: checknext('q15'),
      },
      {
        optionId: '15option04',
        text: <FormattedMessage {...messages.q15option04} />,
        correctAnswer: 0,
        nextStep: checknext('q15'),
      },
    ],
  },
  {
    id: 'q16',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q16Title} />,
    options: [
      {
        optionId: '16option02',
        text: <FormattedMessage {...messages.q16option02} />,
        correctAnswer: 0,
        nextStep: checknext('q16'),
      },
      {
        optionId: '16option01',
        text: <FormattedMessage {...messages.q16option01} />,
        correctAnswer: 1,
        nextStep: checknext('q16'),
      },
      {
        optionId: '16option03',
        text: <FormattedMessage {...messages.q16option03} />,
        correctAnswer: 0,
        nextStep: checknext('q16'),
      },
      {
        optionId: '16option04',
        text: <FormattedMessage {...messages.q16option04} />,
        correctAnswer: 0,
        nextStep: checknext('q16'),
      },
    ],
  },
  {
    id: 'q17',
    type: 'single-option-media',
    category: '2024-Report',
    title: <FormattedMessage {...messages.q17Title} />,
    options: [
      {
        optionId: '17option01',
        text: <FormattedMessage {...messages.q17option01} />,
        correctAnswer: 1,
        nextStep: checknext('q17'),
      },
      {
        optionId: '17option02',
        text: <FormattedMessage {...messages.q17option02} />,
        correctAnswer: 0,
        nextStep: checknext('q17'),
      },
      {
        optionId: '17option03',
        text: <FormattedMessage {...messages.q17option03} />,
        correctAnswer: 0,
        nextStep: checknext('q17'),
      },
      {
        optionId: '17option04',
        text: <FormattedMessage {...messages.q17option04} />,
        correctAnswer: 0,
        nextStep: checknext('q17'),
      },
    ],
  },
  {
    id: 'q18',
    type: 'single-option-media',
    category: 'Pop-Culture',
    title: <FormattedMessage {...messages.q18Title} />,
    options: [
      {
        optionId: '18option02',
        text: <FormattedMessage {...messages.q18option02} />,
        correctAnswer: 0,
        nextStep: checknext('q18'),
      },
      {
        optionId: '18option03',
        text: <FormattedMessage {...messages.q18option03} />,
        correctAnswer: 0,
        nextStep: checknext('q18'),
      },
      {
        optionId: '18option01',
        text: <FormattedMessage {...messages.q18option01} />,
        correctAnswer: 1,
        nextStep: checknext('q18'),
      },
      {
        optionId: '18option04',
        text: <FormattedMessage {...messages.q18option04} />,
        correctAnswer: 0,
        nextStep: checknext('q18'),
      },
    ],
  },
  {
    id: 'q19',
    type: 'single-option-media',
    category: 'Pop culture',
    title: <FormattedMessage {...messages.q19Title} />,
    options: [
      {
        optionId: '19option02',
        text: <FormattedMessage {...messages.q19option02} />,
        correctAnswer: 0,
        nextStep: checknext('q19'),
      },
      {
        optionId: '19option01',
        text: <FormattedMessage {...messages.q19option01} />,
        correctAnswer: 1,
        nextStep: checknext('q19'),
      },
      {
        optionId: '19option03',
        text: <FormattedMessage {...messages.q19option03} />,
        correctAnswer: 0,
        nextStep: checknext('q19'),
      },
      {
        optionId: '19option04',
        text: <FormattedMessage {...messages.q19option04} />,
        correctAnswer: 0,
        nextStep: checknext('q19'),
      },
    ],
  },
  {
    id: 'q20',
    type: 'single-option-media',
    category: 'Pop culture',
    title: <FormattedMessage {...messages.q20Title} />,
    options: [
      {
        optionId: '20option01',
        text: <FormattedMessage {...messages.q20option01} />,
        correctAnswer: 1,
        nextStep: checknext('q20'),
      },
      {
        optionId: '20option02',
        text: <FormattedMessage {...messages.q20option02} />,
        correctAnswer: 0,
        nextStep: checknext('q20'),
      },
      {
        optionId: '20option03',
        text: <FormattedMessage {...messages.q20option03} />,
        correctAnswer: 0,
        nextStep: checknext('q20'),
      },
      {
        optionId: '20option04',
        text: <FormattedMessage {...messages.q20option04} />,
        correctAnswer: 0,
        nextStep: checknext('q20'),
      },
    ],
  },
  {
    id: 'q21',
    type: 'single-option-media',
    category: 'Pop culture',
    title: <FormattedMessage {...messages.q21Title} />,
    options: [
      {
        optionId: '21option02',
        text: <FormattedMessage {...messages.q21option02} />,
        correctAnswer: 0,
        nextStep: checknext('q21'),
      },
      {
        optionId: '21option01',
        text: <FormattedMessage {...messages.q21option01} />,
        correctAnswer: 1,
        nextStep: checknext('q21'),
      },
      {
        optionId: '21option03',
        text: <FormattedMessage {...messages.q21option03} />,
        correctAnswer: 0,
        nextStep: checknext('q21'),
      },
      {
        optionId: '21option04',
        text: <FormattedMessage {...messages.q21option04} />,
        correctAnswer: 0,
        nextStep: checknext('q21'),
      },
    ],
  },
];

export default {
  introduction: {
    title: <FormattedMessage {...messages.introTitle} />,
    ruleTitle: <FormattedMessage {...messages.ruleTitle} />,
    ruleNumber1: <FormattedMessage {...messages.ruleNumber1} />,
    ruleNumber2: <FormattedMessage {...messages.ruleNumber2} />,
    ruleNumber3: <FormattedMessage {...messages.ruleNumber3} />,
    ruleNumber4: <FormattedMessage {...messages.ruleNumber4} />,
    button: <FormattedMessage {...messages.introButton} />,
    imageSrc: 'images/frame.png',
  },
  questions: questionArray,
  helpGuideline: {
    helpLabel: <FormattedMessage {...messages.helpLabel} />,
    lifeLines: <FormattedMessage {...messages.helpGuideline} />,
    buttonHelp1: <FormattedMessage {...messages.buttonHelp1} />,
    imageSrc: 'images/ai-Icon-active.png',
    buttonHelp2: <FormattedMessage {...messages.buttonHelp2} />,
  },
  results: {
    resultsTitle: <FormattedMessage {...messages.resultsFinalResult} />,
    resultsDescription01: (
      <FormattedMessage {...messages.resultsDescription01} />
    ),
    resultsDescription02: (
      <FormattedMessage {...messages.resultsDescription02} />
    ),
    resultsDescription03: (
      <FormattedMessage {...messages.resultsDescription03} />
    ),
    resultsDescription04: (
      <FormattedMessage {...messages.resultsDescription04} />
    ),
    resultsDescriptionButton: (
      <FormattedMessage {...messages.resultsButtonReport} />
    ),
  },
};
